<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-4">
            <label for="">{{ $t('common_words.date_pick') }} </label>
            <el-date-picker
              v-if="renderComponent"
              @change="handleView()"
              v-model="dateTimePicker"
              :picker-options="pickerOptions"
              type="datetime"
              :placeholder="$t('common_words.date_and_hour')"
              :clearable="false"
              class="shadow-sm"
            >
            </el-date-picker>
          </div>
          <div class="col-6">
            <label for="">{{ $t('common_words.export_to_pdf') }}: </label>
            <br />
            <el-select
              clearable
              filterable
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="optionSelect"
              @change="handleView()"
              :placeholder="`${$t('common_words.select2')}...`"
            >
              <el-option
                class="select-default"
                :label="$t('common_words.actual_position')"
                :value="0"
              >
              </el-option>
              <el-option
                class="select-default"
                v-for="item in stations"
                :key="item.id + item.name"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-12">
            <hr />
          </div>
          <div
            class="col-12"
            v-if="currently.currently && Object.keys(currently).length > 0"
          >
            <div class="row">
              <div class="text-center col-xs-12 col-sm-3 col-md-2">
                <img
                  alt=""
                  style="width: 90px"
                  v-bind:src="`/static/img/iconos/${currently.currently.icon}.svg`"
                />
                <p style="font-size: 25px !important"></p>
                <p>{{ currently.currently.summary }}</p>
              </div>
              <div class="col-xs-12 col-sm-9 col-md-10">
                <div class="row">
                  <div
                    class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
                  >
                    <img alt="" src="/static/img/iconos/temperatura.svg" />
                    <span
                      >{{
                        roundNumber(currently.currently.temperature, 1)
                      }}&deg;C</span
                    >
                    <br />
                    <span class="text-muted"
                      ><strong>{{ $t('climate.temperature') }}</strong></span
                    >
                  </div>
                  <div
                    class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
                  >
                    <img alt="" src="/static/img/iconos/humedad.svg" />
                    <span
                      >{{
                        roundNumber(currently.currently.humidity * 100, 2)
                      }}%</span
                    >
                    <br />
                    <span class="text-muted"
                      ><strong>{{ $t('climate.humidity') }}</strong></span
                    >
                  </div>
                  <div
                    class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
                  >
                    <img alt="" src="/static/img/iconos/rain.svg" />
                    <span style="margin-left: 10px"
                      >{{
                        roundNumber(currently.currently.precipIntensity, 1)
                      }}
                      mm/h</span
                    >
                    <br />
                    <span class="text-muted"
                      ><strong>{{ $t('climate.precipitation') }}</strong></span
                    >
                  </div>
                  <div
                    class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
                  >
                    <img alt="" src="/static/img/iconos/lluvia.svg" />
                    <span
                      >{{
                        roundNumber(
                          currently.currently.precipProbability * 100,
                          2
                        )
                      }}%</span
                    >
                    <br />
                    <span class="text-muted"
                      ><strong>{{
                        $t('climate.rain_probability')
                      }}</strong></span
                    >
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <br />
            <div class="row other-climate">
              <div
                class="col-2 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/viento.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.wind') }}:</strong> <br />{{
                    roundNumber(currently.currently.windSpeed * 3.6, 2)
                  }}
                  Km/h
                </p>
              </div>
              <div
                class="col-2 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/barometro.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.pressure') }}:</strong><br />{{
                    currently.currently.pressure
                  }}
                  mb
                </p>
              </div>
              <div
                class="col-2 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/rocio.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.dew_point') }}:</strong><br />{{
                    currently.currently.dewPoint
                  }}&deg;C
                </p>
              </div>
              <div
                class="col-2 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/cloudy.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.cloud') }}:</strong><br />{{
                    roundNumber(currently.currently.cloudCover * 100, 2)
                  }}%
                </p>
              </div>
              <div
                class="col-2 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/niebla.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.visibility') }}:</strong><br />{{
                    roundNumber(currently.currently.visibility, 2)
                  }}
                  Km
                </p>
              </div>
              <div class="col-2 text-center">
                <img alt="" src="/static/img/iconos/ozono.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.ozone') }}:</strong><br />{{
                    currently.currently.ozone
                  }}
                  U.D.
                </p>
              </div>
              <div class="col-12">
                <br />
                <br />
                <p
                  class="text-center text-muted"
                  style="font-family: 'Open Sans', sans-serif"
                >
                  {{ $t('climate.min_temperature') }}:
                  {{ currently.daily.data[0].temperatureMin }} -
                  {{ $t('climate.max_temperature') }}:
                  {{ currently.daily.data[0].temperatureMax }}
                </p>
                <el-slider
                  class="slider-info"
                  style="margin: 0 90px"
                  v-model="rangeSlider"
                  :max="40"
                  :min="10"
                  :marks="marks"
                  :range="true"
                  :disabled="false"
                >
                </el-slider>
                <br />
              </div>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{
                $t('common_words.No_permissions_No_permissions_assigned_space')
              }}
            </h5>
          </div>
        </div>
        <br />
        <br />
      </card>
      <div class="row">
        <div class="col-12 map-climate" style="margin-bottom: 30px !important">
          <div ref="map" class="map" v-if="renderComponent"></div>
          <div
            id="toolbarDiv"
            class="esri-component esri-widget"
            v-if="renderComponent"
          >
            <button
              id="distance"
              class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
              style="margin-bottom: 10px"
              :title="$t('common_words.distance_measurement_tool')"
            ></button>
            <button
              id="area"
              class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
              style="margin-bottom: 10px"
              :title="$t('common_words.area_measurement_tool')"
            ></button>
            <button
              id="clear"
              class="action-button esri-widget--button esri-interactive esri-icon-trash"
              style="margin-bottom: 10px"
              :title="$t('common_words.clear_measurement')"
            ></button>
          </div>
        </div>
      </div>
      <card class="custom-shadow-card-header">
        <span
          v-if="
            Object.keys(chartOptions).length > 0 &&
            Object.values(chartOptions.xAxis.categories).length
          "
        >
          <br />
          <br />
          <div class="row">
            <div class="col-12">
              <highcharts :options="chartOptions"></highcharts>
            </div>
          </div>
        </span>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_assigned_graph') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { TimeSelect, Slider } from 'element-ui';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinCharts from 'src/util/mixinCharts';
import MixinNumbers from 'src/util/mixinNumbers';
import SweetAlert from 'src/class/Alerts';
import moment from 'moment';
import { Chart } from 'highcharts-vue';
import axios from 'axios';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import { Axios } from 'src/class/Axios.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';

export default {
  components: {
    highcharts: Chart,
    [TimeSelect.name]: TimeSelect,
    [Slider.name]: Slider,
  },

  data() {
    return {
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      stations: [],
      currently: [],
      chartOptions: {},
      dateTimePicker: '',
      optionSelect: '',
      rangeSlider: null,
      marks: {
        10: '10°C',
        20: '20°C',
        30: '30°C',
        40: '40°C',
        50: '50°C',
      },
      renderComponent: true,
      map: null,
      pickerOptions: {
        disabledDate(time) {
          let date = new Date();
          return time.getTime() > date.setDate(date.getDate() + 10);
        },
      },
    };
  },

  mixins: [
    MixinPermissions,
    MixinCharts,
    MixinNumbers,
    MixinArcgisMap,
    mixinMasters,
    MixinMenu,
  ],
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    handleRange(min, max) {
      this.rangeSlider = [min, max];
    },

    handleView() {
      this.dateTimePicker =
        moment(String(this.dateTimePicker)).format('YYYY-MM-DD') +
        ' ' +
        moment(String(this.dateTimePicker)).format('hh:mm:ss');

      if (this.optionSelect == 0)
        this.getDataClimateForecast(this.optionSelect, '');
      else {
        for (let index = 0; index < this.stations.length; index++) {
          const element = this.stations[index];
          if (element.id == this.optionSelect) {
            this.getDataClimateForecast(this.optionSelect, element.name);
            break;
          }
        }
      }
    },

    getDataClimateForecast(id, name) {
      let elThis = this;
      if (this.isClimateForecast()) {
        this.showHideLoading(true);

        if (id == 0 || id == null) {
          // let elThis = this
          navigator.geolocation.getCurrentPosition(function (position) {
            elThis.center.lat = position.coords.latitude;
            elThis.center.lng = position.coords.longitude;

            elThis.loadMap();

            axios
              .get(
                '/auth/climates/climatehistorical/' +
                  elThis.dateTimePicker +
                  '/' +
                  position.coords.latitude +
                  ',' +
                  position.coords.longitude
              )
              .then((response) => {
                elThis.currently = response.data;
                elThis.handleRange(
                  elThis.currently.daily.data[0].temperatureMin,
                  elThis.currently.daily.data[0].temperatureMax
                );
                elThis.chartOptions = elThis.spline(
                  'Comportamiento Clim\u00E1tico',
                  'Zona: Posición Actual',
                  elThis.currently.fullDate,
                  elThis.currently.serie_bar
                );
                elThis.showHideLoading();
              });
          });
        } else {
          axios
            .get(
              '/auth/climates/climatehistorical/' +
                this.dateTimePicker +
                '/' +
                id
            )
            .then((response) => {
              this.currently = response.data;

              this.center.lat = this.currently.latitude
                ? parseInt(this.currently.latitude)
                : this.center.lat;
              this.center.lng = this.currently.longitude
                ? parseInt(this.currently.longitude)
                : this.center.lng;

              this.loadMap();

              this.handleRange(
                this.currently.daily.data[0].temperatureMin,
                this.currently.daily.data[0].temperatureMax
              );
              this.chartOptions = this.spline(
                'Comportamiento Clim\u00E1tico',
                'Zona: ' + name,
                this.currently.fullDate,
                this.currently.serie_bar
              );
              this.showHideLoading();
            });
        }
      }
    },

    loadMap() {
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
        this.loadBaseMap(null, true);

        setTimeout(() => {
          document.getElementById('toolbarDiv').style = 'top: 7%;right: 30px';
        }, 10);
      });
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Axios.getMasters('devices/stations/only/all')
        .then((response) => {
          this.stations = response.data.data;
          this.dateTimePicker =
            moment().format('YYYY-MM-DD') + ' ' + moment().format('hh:mm:ss');
          this.optionSelect = 0;
          this.getDataClimateForecast(0, 'Pos. Actual');
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else this.showHideLoading();
  },

  mounted() {
    this.selectedItemOnMenu('climates');
  },

  destroyed() {
    this.deselectedItemOnMenu('climates');
  },
};
</script>
<style></style>
